import { useEffect, useRef, useState } from "react";

const FirmTabReporting = ({ mainRef }) => {
  const tableRef = useRef(null);

  const [availableRows, setAvailableRows] = useState(0);

  useEffect(() => {
    if (!mainRef?.current) return;

    const totalHeight = mainRef.current.getBoundingClientRect().height;
    const availableheight = totalHeight;
    const height = availableheight - 25;

    const rowsFromHeight = Math.floor(height / 25);

    setAvailableRows(Math.max(0, rowsFromHeight - 0));
  }, [mainRef]);

  return (
    <>
      <div
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          width: "100%",
          scrollbarWidth: "none",
        }}
        className="m-b-5 table--no-card invisible-scrollbar rounded-0 border-0 w-100 firm-reporting-table-container"
        ref={tableRef}
      >
        <table
          style={{
            overflowX: "scroll",
          }}
          className="table table-borderless settlement-table"
        >
          <thead>
            <tr
              id="report-tb-header"
              className="settle-t-4 height-25 cursor-default"
              style={{
                background: "var(--primary-10)",
                color: "var(--primary)",
              }}
            >
              <th
                className=""
                style={{
                  width: "35px",
                  minWidth: "35px",
                  maxWidth: "35px",
                  color: "var(--primary-25)",
                }}
              />
              <th colSpan={49} />

              <th
                className=""
                style={{
                  width: "15px",
                  minWidth: "15px",
                  maxWidth: "15px",
                }}
              />
            </tr>
          </thead>
          <tbody id="body-table mb-1" className="table-firm-reporting">
            {Array.from({ length: Math.max(0, availableRows || 0) }).map((_, index) => (
              <tr key={`fake-row-${index}`} style={{ height: "25px" }}>
                <td colSpan={51}>&nbsp;</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default FirmTabReporting;
